<app-overview>
	<app-overview-header>
		<app-overview-header-title>
			<h3 class="mat-body-large">{{"Geforderte Dokumente" | translate : "header-headline"}}</h3>
			<p class="mat-body-medium">{{"Unternehmen müssen folgende Dokumente hochladen" | translate :
				"header-description"}}</p>
		</app-overview-header-title>
		<app-overview-header-search />
		<app-overview-header-filter-chips />
		<app-overview-header-column-chips />
		<app-overview-header-add (addClick)="addCustomerDocument()" />
		<app-overview-header-operators>
			<app-overview-header-refresh />
			<app-overview-header-settings />
		</app-overview-header-operators>
	</app-overview-header>
	@if(tableData().length > 0 && tableConfig(); as tableConfig){
	<app-table>
		@let headers = tableConfig.columnConfig.columns;
		<app-table-header-group>
			<app-table-header-row>
				@for(header of headers; track header.field){
				@if(header.options.isVisible){
				<app-table-header [width]="header.options.widthPx">
					<app-bcl-table-header [header]="header">
						<app-table-column-menu>
							<app-table-column-menu-item-group>
								<app-table-column-menu-item-change-visibility />
							</app-table-column-menu-item-group>
						</app-table-column-menu>
					</app-bcl-table-header>
				</app-table-header>
				}
				}
			</app-table-header-row>
		</app-table-header-group>
		<app-table-data-group>
			<app-virtual-scroll-wrapper appInfiniteScroll [itemSize]="40" [maxBufferPx]="300" [minBufferPx]="200"
				[scrollDebounceTime]="400" [scrollBufferSize]="300">
				@for(data of tableData(); track $index){
				<app-table-data-row *ogsItem>
					@for(header of headers; track header.field){
					@if(header.options.isVisible){
					<app-table-data [width]="header.options.widthPx">
						@let tableData = getDataForField($any(data), header);

						@if(tableData){
						<app-bcl-table-data [tableData]="tableData" (actionClick)="editDocument(data)" />
						}
					</app-table-data>
					}
					}
				</app-table-data-row>
				}
			</app-virtual-scroll-wrapper>
		</app-table-data-group>
	</app-table>
	}
	@else {
	<app-table-skeleton />
	}
</app-overview>

<app-project-documents-menu [(isExpanded)]="isMenuExpanded" [editDocument]="selectedDocument()"
	[projectCustomerDocuments]="tableData()" (delete)="deleteDocument($event)" (add)="addDocument($event)" />